import { Loading, useFetch } from "@4uhub/lib4uhub";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import {
  getNonLaboratorialExamsPdfByIdList,
  getNonLaboratorialExamsPdfByIdListTasy,
} from "../../../../services/nonLaboratorialExams.service";
import { tokenTemporaryService } from "../../../../services/tokenTemorary.service";
import NoData from "../../../UI/NoData";
import { INonLaboratorialExamsPdfResponse } from "../models";
import { FileItem } from "./FileItem/FileItem";
import { IReportsModalProps } from "./models";

export const ReportsModal = memo(({ identifier }: IReportsModalProps) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const [origins, setOrigins] = useState<INonLaboratorialExamsPdfResponse[]>(
    []
  );
  const [selectedFile, setSelectedFile] = useState<string | null>(null);
  const [selectedFileIndex, setSelectedFileIndex] = useState<number>(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setFileLoading] = useState(false);

  const isTemporaryAccess = !!tokenTemporaryService.getTemporaryAccessToken();

  const { sendRequest, loading } = useFetch(
    isTemporaryAccess
      ? getNonLaboratorialExamsPdfByIdListTasy
      : getNonLaboratorialExamsPdfByIdList
  );

  const fetchOrigin = useCallback(async () => {
    const { data, success } = await sendRequest(identifier);
    if (data && success) {
      setOrigins(data);
      setSelectedFileIndex(0);
    }
  }, [identifier, sendRequest]);

  const selectFileHandler = useCallback((value: string | null) => {
    setSelectedFile(value);
  }, []);

  useEffect(() => {
    fetchOrigin();
  }, [fetchOrigin]);

  if (loading) {
    return (
      <Box
        sx={{
          maxHeight: matches ? "calc(100vh - 220px)" : "calc(100vh - 260px)",
        }}
      >
        <Loading size={30} />
      </Box>
    );
  }

  if (origins.length === 0 && !loading) {
    return (
      <Box
        sx={{
          maxHeight: matches ? "calc(100vh - 220px)" : "calc(100vh - 260px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <NoData />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        maxHeight: matches ? "calc(100vh - 220px)" : "calc(100vh - 260px)",
        overflowY: "auto",
      }}
    >
      {origins.map((origin, index) => (
        <FileItem
          key={origin.sequencialControl + index}
          index={index}
          selectedFile={selectedFile}
          origin={origin}
          identifier={identifier}
          isActive={selectedFileIndex === index}
          onSelectFile={selectFileHandler}
          onFileLoading={setFileLoading}
          onGetFileIndex={setSelectedFileIndex}
        />
      ))}
    </Box>
  );
});
